import { useState, useEffect, forwardRef } from 'react'
// ** MUI Imports
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import { DataGrid, gridClasses } from '@mui/x-data-grid'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
// ** Custom Component Import
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { TextField, Typography, useMediaQuery } from '@mui/material'

const TableView = ({
    columns,
    rows,
    total,
    paginationModel,
    setPaginationModel,
    searchValue,
    clearSearch,
    handleSearch,
    title,
    checkboxSelection,
    show,
    //   addUpdate,
    addNew,
    closeForm,
    initialValues,
    formFields,
    validationSchema,
    fetchTableData,
    isLoading,
    viewData,
    closeView,
    updateData,
    customLocaleText,
    pageId,
    isAddButtonVisible,
    viewFields,
    searchBy = '',
    rowHeight // <-- new prop for row height

}) => {
    const theme = useTheme();
    const [tabValue, setTabValue] = useState('All');
    const [updatedRows, setUpdatedRows] = useState(rows)
    const [openAddDialog, setOpenAddDialog] = useState(false)

  const handleAddNewClick = () => {
    setOpenAddDialog(true)
  }

  const handleCloseAddDialog = () => {
    setOpenAddDialog(false)
  }
    useEffect(() => {
        if (tabValue === 'All') {
            setUpdatedRows(rows)
        } else {
            let newRows = rows.filter((row) => row.status === tabValue)
            setUpdatedRows(newRows)
        }
    }, [rows, tabValue])

    useEffect(() => {
        setTabValue('All')
    }, [paginationModel])

    const StyledGridOverlay = styled('div')(({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        '& .ant-empty-img-1': {
            fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626',
        },
        '& .ant-empty-img-2': {
            fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959',
        },
        '& .ant-empty-img-3': {
            fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343',
        },
        '& .ant-empty-img-4': {
            fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c',
        },
        '& .ant-empty-img-5': {
            fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
            fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff',
        },
    }));

    function CustomNoRowsOverlay() {
        return (
            <StyledGridOverlay>
                <svg
                    width="120"
                    height="100"
                    viewBox="0 0 184 152"
                    aria-hidden
                    focusable="false"
                >
                    <g fill="none" fillRule="evenodd">
                        <g transform="translate(24 31.67)">
                            <ellipse
                                className="ant-empty-img-5"
                                cx="67.797"
                                cy="106.89"
                                rx="67.797"
                                ry="12.668"
                            />
                            <path
                                className="ant-empty-img-1"
                                d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                            />
                            <path
                                className="ant-empty-img-2"
                                d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                            />
                            <path
                                className="ant-empty-img-3"
                                d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                            />
                        </g>
                        <path
                            className="ant-empty-img-3"
                            d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
                        />
                        <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
                            <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
                            <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
                        </g>
                    </g>
                </svg>
                <Box sx={{ mt: 1 }}>No Rows</Box>
            </StyledGridOverlay>
        );
    }

    const StyledLinearProgress = styled(LinearProgress)(() => ({
        height: 5,
    }))

    const CustomPagination = ({ paginationModel, setPaginationModel, total }) => {
        const handlePageChange = (newPage) => {
          setPaginationModel((prev) => ({ ...prev, page: newPage }));
        };
      
        const totalPages = Math.ceil(total / paginationModel.pageSize);
        if (totalPages <= 1) return null;
        const startEntry = paginationModel.page * paginationModel.pageSize + 1;
        const endEntry = Math.min(startEntry + paginationModel.pageSize - 1, total);
      
        // Helper to create a list of visible page numbers with ellipsis
        const getVisiblePages = () => {
          const pages = [];
          if (totalPages <= 10) {
            // If there are 10 or fewer pages, show them all.
            for (let i = 0; i < totalPages; i++) {
              pages.push(i);
            }
          } else {
            // Always show first and last pages.
            pages.push(0);
      
            // Determine range around current page.
            const left = Math.max(paginationModel.page - 1, 1);
            const right = Math.min(paginationModel.page + 1, totalPages - 2);
      
            // Add ellipsis if there's a gap between the first page and the start of the range.
            if (left > 1) {
              pages.push("start-ellipsis");
            }
      
            // Add pages around current page.
            for (let i = left; i <= right; i++) {
              pages.push(i);
            }
      
            // Add ellipsis if there's a gap between the end of the range and the last page.
            if (right < totalPages - 2) {
              pages.push("end-ellipsis");
            }
      
            pages.push(totalPages - 1);
          }
          return pages;
        };
      
        const visiblePages = getVisiblePages();
      
        return (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ padding: '10px', borderTop: '1px solid #E5E7EB' }}
          >
            <Typography variant="body2">
              Showing {total > 0 ? startEntry : 0} to {total > 0 ? endEntry : 0} of {total} entries
            </Typography>
      
            {/* Pagination Controls */}
            <Box display="flex" alignItems="center" gap={1}>
              <IconButton
                size="small"
                disabled={paginationModel.page === 0}
                onClick={() => handlePageChange(paginationModel.page - 1)}
              >
                <ChevronLeftIcon />
              </IconButton>
      
              {visiblePages.map((page, index) => {
                if (page === "start-ellipsis" || page === "end-ellipsis") {
                  return (
                    <Typography key={index} sx={{ width: '35px', textAlign: 'center' }}>
                      …
                    </Typography>
                  );
                }
                return (
                  <Button
                    key={page}
                    size="small"
                    variant={paginationModel.page === page ? "contained" : "outlined"}
                    onClick={() => handlePageChange(page)}
                    sx={{
                      background: paginationModel.page === page ? theme.palette.primary.main : 'transparent',
                      color: paginationModel.page === page ? theme.palette.secondary.main : '#000000',
                      border: "1px solid #E5E7EB",
                      width: '35px',
                      height: '35px',
                      minWidth: '35px',
                      boxShadow: 'none'
                    }}
                  >
                    {page + 1}
                  </Button>
                );
              })}
      
              <IconButton
                size="small"
                disabled={paginationModel.page >= totalPages - 1}
                onClick={() => handlePageChange(paginationModel.page + 1)}
              >
                <ChevronRightIcon />
              </IconButton>
            </Box>
          </Box>
        );
      };
      
    

    const hidden = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box >
            <CardHeader
                // title={<Typography variant="h4" component="div">
                //     {title}
                // </Typography>}
                className={hidden ? 'responsiveView' : ''}
                sx={{ fontWeight: 'fontWeightMedium', p: 1,}}
                action={
                    <Box sx={{ rowGap: 4, display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: '10px', marginBottom:2 }}>
                        {pageId !== 'welcome-plans-list' && pageId !== 'regular-plans-list' ? <TextField
                            value={searchValue}
                            placeholder={searchBy ? `Search with ${searchBy}` : 'Search...'}
                            onChange={handleSearch}
                            InputProps={{
                                startAdornment: (
                                    <Box sx={{ mr: 2, display: 'flex' }}>
                                        <SearchIcon />
                                    </Box>
                                ),
                                endAdornment: (
                                    <IconButton size='small' style={{ visibility: searchValue ? 'visible' : 'hidden' }} title='Clear' aria-label='Clear' onClick={clearSearch}>
                                        <CloseIcon />
                                    </IconButton>
                                )
                            }}
                            sx={{
                                width: {
                                    xs: 1,
                                    md: 'auto'
                                },
                                '& .MuiInputBase-root > svg': {
                                    mr: 2
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: '10px 0px', // Adjust padding for the input itself
                                },
                            }}
                        /> : ''}
                        {isAddButtonVisible && 
                        pageId !=="user-list"  ?
                        <Button variant='contained' 
                         sx={{ '& svg': { mr: 2 }, textTransform:'none', background:'#000000', color:'#ffffff' }} onClick={handleAddNewClick}
                        >
                            {/* <Icon fontSize='1.125rem' icon='tabler:plus' /> */}
                            {/* <AddIcon /> */}
                            {`Add New ${title}`}
                        </Button> : ''}     
                    </Box>
                }
            />
            <DataGrid
                // loading={isLoading}
                disableColumnMenu={true}
                disableDensitySelector={true}
                disableVirtualization={true}
                // onCellClick={(params, event) => { event.preventDefault(); }}
                isRowSelectable={false}
                ignoreDiacritics={false}
                disableRowSelectionOnClick={true}
                disableColumnResize
                disableSelectionOnClick={false}
                disableColumnSelector={true}
                disableColumnFilter={true}
                getRowId={(row) => row.id}
                autoHeight
                // pagination
                rows={updatedRows}
                rowCount={total}
                columns={columns}
                checkboxSelection={checkboxSelection}
                paginationMode='server'
                // pageSizeOptions={paginationSize}
                // paginationModel={paginationModel}
                // onPaginationModelChange={(data) => {
                //     fetchTableData(searchValue, data.page)
                //     setPaginationModel(data);
                // }}
                pagination={false}
                localeText={customLocaleText}
                rowHeight={rowHeight || '100px'}
                slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                    loadingOverlay: StyledLinearProgress,
                    footer: () => (
                        <CustomPagination 
                            paginationModel={paginationModel} 
                            setPaginationModel={setPaginationModel} 
                            total={total} 
                        />
                    ),            
                }}
                // getRowHeight={() => 'auto'}
                getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : ''
                }
                sx={{
                    [`& .${gridClasses.cell}`]: {
                        py: 1,
                    },
                    '& .MuiDataGrid-cell:focus': {
                        outline: 'none', // Removes the focus outline
                      },
                      '& .MuiDataGrid-cell:focus-within': {
                        outline: 'none', // Removes focus-within outline
                      },
                      '& .even-row': {
                        backgroundColor: '#f4f6f9', // Alternating row color
                      }
                }}
                
            />
            {/* <CustomPagination paginationModel={paginationModel} setPaginationModel={setPaginationModel} total={total} /> */}
        </Box>
    )
}

export default TableView
